function getCryptoRandomBetween(min, max) {
  //the highest random value that crypto.getRandomValues could store in a Uint32Array
  const MAX_VAL = 4294967295;

  //find the number of randoms we'll need to generate in order to give every number between min and max a fair chance
  const numberOfRandomsNeeded = Math.ceil((max - min) / MAX_VAL);

  //grab those randoms
  const cryptoRandomNumbers = new Uint32Array(numberOfRandomsNeeded);
  crypto.getRandomValues(cryptoRandomNumbers);

  //add them together
  let sum = 0;
  for (let i = 0; i < cryptoRandomNumbers.length; i++) {
    sum += cryptoRandomNumbers[i];
  }

  //and divide their sum by the max possible value to get a decimal
  const randomDecimal = sum / (MAX_VAL * numberOfRandomsNeeded);

  //if result is 1, retry. otherwise, return decimal.
  return randomDecimal === 1 ? getCryptoRandomBetween(min, max) : Math.floor(randomDecimal * (max - min + 1) + min);
}

function getRandomChar(str) {
  return str.charAt(getCryptoRandomBetween(0, str.length - 1));
}

export function randomCharacters(length, characters) {
  let str = '';
  for (let i = 0; i < length; i++) {
    str += getRandomChar(characters);
  }
  return str;
}

export function randomString(length) {
  return randomCharacters(length, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789');
}
